var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6C15.64 6 18.7509 8.41221 20 11.8174C18.7514 15.2238 15.6403 17.6364 12 17.6364C8.36003 17.6364 5.24911 15.2242 4 11.819C5.24861 8.4126 8.35973 6 12 6ZM12 8.18182C9.99169 8.18182 8.36364 9.80987 8.36364 11.8182C8.36364 13.8265 9.99169 15.4545 12 15.4545C14.0083 15.4545 15.6364 13.8265 15.6364 11.8182C15.6364 9.80987 14.0083 8.18182 12 8.18182ZM12 9.63636C13.205 9.63636 14.1818 10.6132 14.1818 11.8182C14.1818 13.0232 13.205 14 12 14C10.795 14 9.81818 13.0232 9.81818 11.8182C9.81818 10.6132 10.795 9.63636 12 9.63636Z",
    fill: "#75593A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewedIcon);
export default __webpack_public_path__ + "static/media/viewedIcon.71a91dfec91d5e536abb9c18db14576f.svg";
export { ForwardRef as ReactComponent };